// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__25kDE","form":"styles_form__1iPs1"};